var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSicon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9967 2.69312H17.7625C18.0589 2.69312 18.3431 2.81201 18.5527 3.02364C18.7623 3.23527 18.88 3.5223 18.88 3.8216V22.4415C18.88 22.7408 18.7623 23.0278 18.5527 23.2395C18.3431 23.4511 18.0589 23.57 17.7625 23.57H2.1175C1.82112 23.57 1.53688 23.4511 1.32731 23.2395C1.11774 23.0278 1 22.7408 1 22.4415V3.8216C1 3.5223 1.11774 3.23527 1.32731 3.02364C1.53688 2.81201 1.82112 2.69312 2.1175 2.69312H6.02875V4.38584H13.8512V2.69312H14.9967Z",
    stroke: "#A9DFD8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6166 9.4636L7.14655 13.9781H12.7363L8.26405 18.492M6.02905 1H13.8516V4.38544H6.02905V1Z",
    stroke: "#A9DFD8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSicon2);
export default __webpack_public_path__ + "static/media/sicon2.597167813a9b8e91cb388adb9631b4a3.svg";
export { ForwardRef as ReactComponent };